import { useRouter } from "next/router";
import { useContext } from "react";
import { CheckoutContext } from "contexts/CheckoutProvider";

const useCheckoutValidator = ({
  flow,
  withProperties = [],
  withoutProperties = [],
  redirectRoute,
}) => {
  const router = useRouter();
  const { session } = useContext(CheckoutContext);

  const sessionHydrated = {
    "give-subscription": session?.type === "gift",
    join: session?.type === "subscription",
    subscribe: session?.type === "subscription",
    profile: true,
    guidedSignUpFunnel: session?.type === "subscription",
  }[flow];

  if (!sessionHydrated) {
    return { showPage: false };
  }

  let redirectPage = false;
  withProperties.forEach((p) => {
    if (!session[p]) redirectPage = true;
  });
  withoutProperties.forEach((p) => {
    if (session[p]) redirectPage = true;
  });

  if (redirectPage) {
    router.replace(redirectRoute);
    return { showPage: false };
  }

  return { showPage: true, hydratedSession: session };
};

export default useCheckoutValidator;
